export default __webpack_public_path__ + "static/g2_red-3fb321b6215fb31701e121b3c932d4b0.svg";